// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'

class SaveState extends React.Component {
	render() {
		const { isDirty, saveIsProcessing, saveIsProcessed, saveIsUnsuccessful, saveIsSuccessful, saveIsFinishing, saveError } = this.props
		let className = 'save-state'
		let showLoading = false

		if ( saveIsProcessing ) {
			className += ' -is-processing'
		}

		if ( saveIsProcessed ) {
			className += ' -is-processed'
		}

		if ( saveIsUnsuccessful ) {
			className += ' -is-unsuccessful'
		}

		if ( saveIsSuccessful ) {
			className += ' -is-successful'
		}

		if ( saveIsFinishing ) {
			className += ' -is-finishing'
		}

		if ( saveIsProcessing ) {
			showLoading = true
		}

		if ( saveIsProcessed && ! saveIsUnsuccessful && ! saveIsSuccessful ) {
			showLoading = true
		}

		if ( saveError ) {
			className += ' -has-error'
			showLoading = false
		}

		return (
			<div className={ className }>
				{ showLoading &&
					<div className="-state">
						<LoadingSpinner />
					</div>
				}

				{ saveIsUnsuccessful &&
					<div className="-state">
						<i className="icon-exclamation-circle"></i>

						{ saveError &&
							<div className="-error-message">
								<p>{ saveError }</p>
							</div>
						}
					</div>
				}

				{ saveIsSuccessful &&
					<div className="-state">
						<i className="icon-check"></i>
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isDirty: state.account.isDirty,
		saveIsProcessing: state.account.saveIsProcessing,
		saveIsProcessed: state.account.saveIsProcessed,
		saveIsUnsuccessful: state.account.saveIsUnsuccessful,
		saveIsSuccessful: state.account.saveIsSuccessful,
		saveIsFinishing: state.account.saveIsFinishing,
		saveError: state.account.saveError,
	}
}

export default connect( mapStateToProps )( SaveState )



// WEBPACK FOOTER //
// ./components/SaveState/SaveState.jsx